// eslint-disable-next-line import/no-cycle
import store from '@/store';
import { findNavItemByRoute } from '@/utils/customerNavigation';
import {
  catalogKeyForCustomerRoute,
  isFeatureManagedCustomerRoute,
} from '@/utils/customerRoutes.catalog';

function accessForRoute(path) {
  const catalogKey = catalogKeyForCustomerRoute(path);
  if (!catalogKey) return null;
  const byKey = store.getters.getFeatureAccessByKey || {};
  return byKey[catalogKey] ?? null;
}

/**
 * Enforce tenant feature access on customer routes after session ping/login.
 * Uses `featureAccessByKey` (server truth) when available, then sidebar nav.
 */
export function checkFeatureAccess(to, from, next) {
  const path = to.path || '';

  if (path === '/gated-feature' || path.startsWith('/gated-feature/')) {
    next();
    return;
  }

  if (!isFeatureManagedCustomerRoute(path)) {
    next();
    return;
  }

  if (!store.getters.useCustomerNavigation) {
    next('/');
    return;
  }

  const featureAccess = accessForRoute(path);
  if (featureAccess) {
    if (!featureAccess.visible) {
      next('/');
      return;
    }
    if (featureAccess.locked) {
      next({
        name: 'gatedFeature',
        query: { route: path },
      });
      return;
    }
    next();
    return;
  }

  const nav = store.getters.getCustomerNavigation || [];
  const match = findNavItemByRoute(nav, path);
  if (!match || match.itemKind !== 'link') {
    next('/');
    return;
  }

  if (match.locked) {
    next({
      name: 'gatedFeature',
      query: { route: path },
    });
    return;
  }

  next();
}
